// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__Y1bgv","inputWrap":"CustomTip_inputWrap__1s--U"};